/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './c3js-chart.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/c3js-chart/c3js-chart.component';
const styles_C3JSChartComponent:any[] = [i0.styles];
export const RenderType_C3JSChartComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_C3JSChartComponent,data:{}});
export function View_C3JSChartComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{divEl:0}),(_l()(),i1.ɵeld(0,[[1,0],['div',
      1]],(null as any),0,'div',[['class','chart']],(null as any),(null as any),(null as any),
      (null as any),(null as any)))],(null as any),(null as any));
}
export function View_C3JSChartComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-c3js-chart',
      ([] as any[]),(null as any),(null as any),(null as any),View_C3JSChartComponent_0,
      RenderType_C3JSChartComponent)),i1.ɵdid(4898816,(null as any),0,i2.C3JSChartComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const C3JSChartComponentNgFactory:i1.ComponentFactory<i2.C3JSChartComponent> = i1.ɵccf('admin-c3js-chart',
    i2.C3JSChartComponent,View_C3JSChartComponent_Host_0,{columns:'columns',type:'type',
        group:'group',x:'x',subchart:'subchart',colorPattern:'colorPattern',showAxis:'showAxis',
        showLegend:'showLegend'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2MzanMtY2hhcnQvYzNqcy1jaGFydC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvYzNqcy1jaGFydC9jM2pzLWNoYXJ0LmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2MzanMtY2hhcnQvYzNqcy1jaGFydC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2MzanMtY2hhcnQvYzNqcy1jaGFydC5jb21wb25lbnQudHMuQzNKU0NoYXJ0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiAjZGl2IGNsYXNzPVwiY2hhcnRcIj48L2Rpdj4iLCI8YWRtaW4tYzNqcy1jaGFydD48L2FkbWluLWMzanMtY2hhcnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O21EQ0FBO01BQUE7TUFBQTs7O29CQ0FBO01BQUE7bUNBQUEsVUFBQTtNQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/c3js-chart/c3js-chart.component.ngfactory.ts